import View from "../../../View"
import TeamAssignmentsPanelContent from "./TeamAssignmentsPanelContent"
import {setEventPreventHidingEditUserSlidingPanel} from "../../utils"
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from "../../constants"
import PanelContainer from "../../../components/PanelContainer"
import LoadingContainer from "../../../util/LoadingContainer"
import {UserTeamAssignmentType} from '../constants'

export default class TeamAssignmentsPanelContainer extends View {
    constructor({
        showCopyButton = true,
        additionalClass = '',
        onPanelHide = () => {},
        onCloseButtonClick = () => {},
        changeTeamAssignments = () => {},
        loadTeamAssignmentsData = () => {},
        showCopyContent = () => {},
    }) {
        super()

        this.params = {
            additionalClass,
            showCopyButton,
        }

        this.callbacks = {
            onPanelHide,
            onCloseButtonClick,
            changeTeamAssignments,
            loadTeamAssignmentsData,
            showCopyContent,
        }

        this.state = {
            isShown: false,
            userPanelOpenedBelow: false,
            needToLoadData: false,
            loading: false,
            disabled: false,

            assignedGroupIds: [],
            assignedUserIds: [],
            users: [],
            userGroups: [],
            isUGREnabled: false,
            teamAssignmentType: UserTeamAssignmentType.SELECTED,
            userFML: {},
            userId: '',

            showCopyContent: false,
            copyContentLoading: false,
        }

        this.onStatePropertyChanged('isShown', (isShown) => {
            this.teamAssignmentsPanelContainer.setState({isShown: isShown})
            if (isShown)
                this.teamAssignmentsPanel.update()
        })

        this.onStatePropertyChanged('userPanelOpenedBelow', (userPanelOpenedBelow) => {
            this.teamAssignmentsPanel.setState({
                withBackButton: userPanelOpenedBelow
            })
        })

        this.onStatePropertyBecameTrue('needToLoadData', () => {
            this.callbacks.loadTeamAssignmentsData()
        })

        this.onStatePropertyChanged('loading', (loading) => {
            this.teamAssignmentsLoadingContainer.setState({
                loading: loading
            })
        })

        this.onStatePropertyChanged('disabled', disabled => this.teamAssignmentsPanel.setState({disabled}))

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'teamAssignmentType', 'assignedGroupIds', 'assignedUserIds', 'isUGREnabled'], () => {
            this.teamAssignmentsPanel.setState({
                teamAssignmentType: this.state.teamAssignmentType,
                assignedGroupIds: this.state.assignedGroupIds,
                assignedUserIds: this.state.assignedUserIds,
                users: this.state.users,
                userGroups: this.state.userGroups,
                isUGREnabled: this.state.isUGREnabled,
            })
        })

        this.onStatePropertyChanged('userFML', userFML => {
            this.teamAssignmentsPanel.setState({
                userFML: userFML
            })
        })

        this.onStatePropertyChanged('userId', (userId) => {
            this.teamAssignmentsPanel.setState({
                userId: userId
            })
        })

        this.onStatePropertyChanged('showCopyContent', showCopyContent => this.teamAssignmentsPanel.setState({showCopyContent}))
        this.onStatePropertyChanged('copyContentLoading', copyContentLoading => this.teamAssignmentsPanel.setState({copyContentLoading}))
    }

    afterRender() {
        this.teamAssignmentsPanel = new TeamAssignmentsPanelContent({
            showCopyButton: this.params.showCopyButton,
            onChangeDialogData: (data) => {
                this.callbacks.changeTeamAssignments({
                    teamAssignmentType: data.teamAssignmentType,
                    assignedGroupIds: data.assignedGroupIds,
                    assignedUserIds: data.assignedUserIds,
                })
            },
            onCopyFromButtonClick: this.callbacks.showCopyContent,
            onBackButtonClick: () => this.callbacks.onPanelHide(),
            onClickDialogContent: (e) => setEventPreventHidingEditUserSlidingPanel(e)
        })

        this.teamAssignmentsLoadingContainer = new LoadingContainer({
            contentComponent: this.teamAssignmentsPanel,
            containerClass: 'teamAssignmentPanelLoadingWrapper',
            loadingMoireConfig: {
                delay: 500
            }
        })

        this.teamAssignmentsPanelContainer = new PanelContainer({
            component: this.teamAssignmentsLoadingContainer,
            additionalClass: `team_assignment_panel ${this.params.additionalClass}`,
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            showHideButton: true,
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.TEAM_ASSIGNMENT,
            },
            onHideCallback: () => this.callbacks.onPanelHide(),
            onClickCloseButton: () => this.callbacks.onCloseButtonClick(),
            hideHandler: () => this.teamAssignmentsPanelContainer.setState({isShown: false}),
        }).init(this.$containerEl)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/teamAssignmentsPanel/TeamAssignmentsPanelContainer.js